import axios from 'axios';

export const biometricApi = axios.create({
  baseURL: process.env.REACT_APP_BIOMETRIC_API,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
